export function getThemeStyles(theme) {
  return require("./".concat(theme, ".css"));
}